// libraries
import { Fragment, useContext } from "react";
import React from "react";
// hooks and contexts
import { ThemeContext } from "~/theme";
// enums
import { IDocObject } from "~/interfaces";
// styles
import * as BannerStyles from "~/components/views/banner-option/Styled";
import { Header } from "~/components/views/page-template/Styled";
// components
import BannerOption, { EDefaultValue } from "~/components/views/banner-option/BannerOption";
// constants
import SiteNavContext from "~/navigation/SiteNavContext";

declare var __CLIENT_URL__: string;

const DOC_STRINGS: IDocObject[] = [
    {
        title: "Terms of Use",
        url: `/terms-of-use`
    }
];

export type IProps = {
    //
};

export const DisclosuresSection: React.FC<IProps> = (props) => {
    
    const navContext = useContext(SiteNavContext)
    const theme: any = React.useContext(ThemeContext);

    return (
        <Fragment>

            <Header> { `Disclosures` } </Header>

            <BannerStyles.BannerOptionSection>

                {DOC_STRINGS.map(
                    (docObject: IDocObject) => {
                        return (
                            <BannerOption key={docObject.title}
                                clickCallback={() => {navContext.navigate(docObject.url)}}
                                label={
                                    <Fragment>
                                        <BannerStyles.OptionLabel color={theme.colors["primary"].rgba}>{docObject.title}</BannerStyles.OptionLabel>
                                    </Fragment>
                                }
                                defaultValue={EDefaultValue["chevron-right"]}
                            />
                        );
                    }
                )}

                <BannerOption key={"Privacy Policy"}
                    clickCallback={() => { window.open(`${__CLIENT_URL__}/privacy-policy.html`, "_blank", "noopener,noreferrer");}}
                    label={
                        <Fragment>
                            <BannerStyles.OptionLabel color={theme.colors["primary"].rgba}>Privacy Policy</BannerStyles.OptionLabel>
                        </Fragment>
                    }
                    defaultValue={EDefaultValue["external-link"]}
                />
                
            </BannerStyles.BannerOptionSection>

        </Fragment>
    );
};

export default DisclosuresSection;